import * as React from "react";
import { LineChart } from "@mui/x-charts/LineChart";
import { useTranslation } from "react-i18next";

function CustomTick({ x, y, value, range, locale }) {
  const d = value instanceof Date ? value : new Date(value);

  let label;
  if (["1H", "3H", "6H", "12H", "1D"].includes(range)) {
    label = d.toLocaleTimeString(locale, {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  } else {
    label = d.toLocaleDateString(locale, {
      day: "2-digit",
      month: "short",
    });
  }

  return (
    <text x={x} y={y} textAnchor="middle" fontSize={11} fill="#444">
      {label}
    </text>
  );
}

export default function MeasurementsChart({ data, range, onRangeChange, deviceType }) {
  const { t, i18n } = useTranslation();
  const locale = i18n.language === "tr" ? "tr-TR" : "en-US";
  const now = new Date();
  const showMarks = ["1H", "3H"].includes(range);
  let min;
  switch (range) {
    case "1H": min = new Date(now.getTime() - 1 * 60 * 60 * 1000); break;
    case "3H": min = new Date(now.getTime() - 3 * 60 * 60 * 1000); break;
    case "6H": min = new Date(now.getTime() - 6 * 60 * 60 * 1000); break;
    case "12H": min = new Date(now.getTime() - 12 * 60 * 60 * 1000); break;
    case "1D": min = new Date(now.getTime() - 1 * 24 * 60 * 60 * 1000); break;
    case "3D": min = new Date(now.getTime() - 3 * 24 * 60 * 60 * 1000); break;
    case "1W": min = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000); break;
    default: min = new Date(now.getTime() - 24 * 60 * 60 * 1000);
  }
  const max = now;

  // Grup Arge'de nötr akım yok
  const showNeutral = deviceType !== "gruparge";

  return (
    <div>
      {/* Filtre Butonları */}
      <div className="flex flex-wrap gap-2 mb-4 justify-center md:justify-start">
        {[
          { key: "1H", label: t('timeRanges.1H') },
          { key: "3H", label: t('timeRanges.3H') },
          { key: "6H", label: t('timeRanges.6H') },
          { key: "12H", label: t('timeRanges.12H') },
          { key: "1D", label: t('timeRanges.1D') },
          { key: "3D", label: t('timeRanges.3D') },
          { key: "1W", label: t('timeRanges.1W') },
        ].map((r) => (
          <button
            key={r.key}
            onClick={() => onRangeChange(r.key)}
            className={`px-3 py-2 rounded-md border text-sm font-medium transition
              ${range === r.key
                ? "bg-red-600 text-white border-red-600"
                : "bg-white text-gray-800 border-gray-300 hover:bg-gray-100"}`}
          >
            {r.label}
          </button>
        ))}
      </div>

      <LineChart
        dataset={data}
        xAxis={[
          {
            dataKey: "time",
            scaleType: "time",
            position: "bottom",
            min: min.getTime(),
            max: max.getTime(),
            tickNumber: 8,
            tickLabel: (props) => <CustomTick {...props} range={range} locale={locale} />,
            valueFormatter: (value) => {
              const d = value instanceof Date ? value : new Date(value);
              if (["1H", "3H", "6H", "12H", "1D"].includes(range)) {
                return d.toLocaleTimeString(locale, {
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: false,
                });
              } else {
                return d.toLocaleDateString(locale, {
                  day: "2-digit",
                  month: "short",
                });
              }
            },
          },
        ]}
        series={[
          { dataKey: "I1", label: t('chartLabels.I1'), color: "#e63946", showLine: true, showMark: showMarks },
          { dataKey: "I2", label: t('chartLabels.I2'), color: "#2a9d8f", showLine: true, showMark: showMarks },
          { dataKey: "I3", label: t('chartLabels.I3'), color: "#1d3557", showLine: true, showMark: showMarks },
          ...(showNeutral ? [{ dataKey: "IN", label: t('chartLabels.neutral'), color: "#6b7280", showLine: true, showMark: showMarks }] : []),
        ]}
        height={350}
        axisHighlight={{ x: "line" }}
        slotProps={{
          legend: {
            direction: 'row',
            position: { vertical: 'top', horizontal: 'middle' },
            padding: 0,
          },
          tooltip: { trigger: "axis" },
        }}
      />
    </div>
  );
}
